import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, ValidatorFn } from '@angular/forms';
import { LocalisationService } from '../services/localisation.service';

@Directive({
    selector: '[appPatient]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PatientValidatorDirective, multi: true }]
})

export class PatientValidatorDirective {

}

export function phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value) {
            const tel = control.value.replace(/\D/g, '');
            if (tel.match(/^0\d{9}$/)) {
                return null;
            }

            if (tel.match(/^377\d{8}$/) || tel.match(/^00377\d{8}$/)) { // Indicatif Monégasque
                return null;
            }

            if (tel.match(/^39\d{9}$/) || tel.match(/^0039\d{9}$/)) { // Indicatif Italien
                return null;
            }

            if (tel.match(/^44\d{8}$/) || tel.match(/^0044\d{8}$/)) { // Indicatif Anglais
                return null;
            }

            if (tel.match(/^49\d{11}$/) || tel.match(/^0049\d{11}$/)) { // Indicatif Allemand
                return null;
            }

            if (tel.match(/^34\d{9}$/) || tel.match(/^0034\d{9}$/)) { // Indicatif Espagnol
                return null;
            }

            if (tel.match(/^32\d{9}$/) || tel.match(/^0032\d{9}$/)) { // Indicatif Belge
                return null;
            }

            if (tel.match(/^33\d{9}$/)) {
                return null;
            }

            if (tel.match(/^\d{9}$/)) {
                return null;
            }

            return {forbidden : {value: control.value}};
        }
        return null;
    };
}

export function consentValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const forbidden = !control.value;
        return forbidden ? {forbidden: {value: control.value}} : null;
    };
}

export function insValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value) {
            const ins = control.value.replace(/\D/g, '');

            if (ins.match(/^[1-2]\d{14}$/)) {
                return null;
            }
            
            return {forbidden : {value: control.value}};
        }
        
        return {forbidden : {value: control.value}};
    };
}

export function responsable(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const haveResponsable = control.parent?.value.responsable;
        if (haveResponsable === 'true') {
            if (control.value == '' || control.value == 'undefined') {
                return {required: {value: control.value}};
            }
        }
        return null;
    };
}
